import React from 'react';

// A userlist row that hasn't loaded: UserlistComponent fills unloaded rows with
// it, and the People column's skeleton lists a few before the app loads.
export default function UserlistSkeletonRow({ style }) {
	return (
		<div style={style} className='userlist-skeleton-row' aria-hidden='true'>
			<span className='userlist-skeleton-row__bar userlist-skeleton-row__bar--name' />
			<span className='userlist-skeleton-row__bar userlist-skeleton-row__bar--preview' />
		</div>
	);
}
